var map = {
	"./dconfig.png": 22,
	"./dinventory.png": 23,
	"./dweapons.png": 24,
	"./episodeswitcher.png": 25,
	"./formtemplate.png": 26,
	"./project.png": 27,
	"./yourdevtools.png": 28
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21;